export default __webpack_public_path__ + "static/media/Sume_SalvadorRivas.6447883b.png";